/**
 *  催付效果汇总
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Balloon, Button, DatePicker, Radio, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import ParagraphTitle from '@/components/ParagraphTitle';
import LzMessage from '@/components/common/LzMessage';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import styles from './index.module.scss';

const PaymentEffect = () => {
  const { Tooltip } = Balloon;
  // 获取列表信息
  const [dataList, setDataList] = useState([]);
  // 获取效果信息
  const [dataEffect, setDataEffect] = useState({
    promptOrderNum: 0,
    returnOrderNum: 0,
    returnPayAmount: 0,
    successRate: 0,
  } as object);
  // 每日效果分析loading
  const [isLoading, setLoading] = useState(false);

  // 活动form查询条件
  const [formSelect, setFormSelect] = useState({
    startTime: moment(new Date().getTime() - 6 * 24 * 60 * 60 * 1000).format('YYYY-MM-DD'), // 活动开始时间
    endTime: moment(new Date().getTime()).format('YYYY-MM-DD'), // 活动结束时间
  });
  const [initTab, setInitTab] = useState(6);
  // tab标签列表
  const tabList = [
    {
      label: '近7天',
      value: 6,
    },
    {
      label: '近15天',
      value: 14,
    },
    {
      label: '近30天',
      value: 29,
    },
  ];
  // 选择天数
  const chooseTab = (v, e) => {
    // console.log('-------------',v,e.target)
    setFormSelect((formSelect) => {
      formSelect.startTime = moment(new Date().getTime() - v * 24 * 60 * 60 * 1000).format('YYYY-MM-DD');
      formSelect.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
      // console.log('-------------', formSelect)
      return formSelect;
    });
    setInitTab(() => v);
    search();
  };
  // 选择时间
  const selectTime = (value) => {
    let startT = '';
    let endT = '';
    // console.log('-------------',value)
    startT = value[0] ? moment(value[0]).format('YYYY-MM-DD') : '';
    endT = value[1] ? moment(value[1]).format('YYYY-MM-DD') : '';
    // console.log(startT, endT);
    setFormSelect({ ...formSelect, startTime: startT, endTime: endT });
  };
  // 按钮查询
  const search = () => {
    searchEffect();
    searchList();
  };
  // 查询效果
  const searchEffect = () => {
    const params = {
      startTime: formSelect.startTime ? moment(`${formSelect.startTime} 00:00:00`).valueOf() : '',
      endTime: formSelect.endTime ? moment(`${formSelect.endTime} 23:59:59`).valueOf() : '',
    };
    Servlets('getPaymentEffectSummary', params).then((res: { data: object }) => {
      setDataEffect(res.data ? res.data : dataEffect);
    });
  };
  // 查询效果列表
  const searchList = (v) => {
    const date = (moment(formSelect.endTime).valueOf() - moment(formSelect.startTime).valueOf()) / (24 * 60 * 60 * 1000);
    if (date !== 6 && date !== 14 && date !== 29) {
      setInitTab(1);
    }
    // setLoading(true);
    const params = {
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      startTime: formSelect.startTime ? moment(`${formSelect.startTime} 00:00:00`).valueOf() : '',
      endTime: formSelect.endTime ? moment(`${formSelect.endTime} 23:59:59`).valueOf() : '',
      ...v,
    };
    Servlets('getPaymentEffectList', params).then((res) => {
      if (!res.data) {
        setLoading(false);
        return;
      }
      setDataList(res.data);
      setPageInfo({ ...pageInfo, total: res.page.total, pageNo: res.page.pageNo, pageSize: res.page.pageSize });
      // setLoading(false);
    });
  };
  // 重置
  const resetFilter = () => {
    setFormSelect((formSelect) => {
      formSelect.startTime = moment(new Date().getTime() - 6 * 24 * 60 * 60 * 1000).format('YYYY-MM-DD'); // 活动开始时间
      formSelect.endTime = moment(new Date().getTime()).format('YYYY-MM-DD'); // 活动结束时间
      return formSelect;
    });
    setInitTab(6);
    search();
  };
  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 翻页方法
  const handleTaskPageSizeChange = async (pages = {}) => {
    // setLoading(true);
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      // TODO 请求后端列表接口
      searchList({ pageSize: pages.pageSize, pageNo: pages.pageNo });
    } catch (e) {
      // setLoading(false);
      LzMessage.error(e.message, '');
    }
  };

  // 导出
  const downLoad = () => {
    const params = {
      startTime: formSelect.startTime ? moment(`${formSelect.startTime} 00:00:00`).valueOf() : '',
      endTime: formSelect.endTime ? moment(`${formSelect.endTime} 23:59:59`).valueOf() : '',
    };
    Servlets('getEffectExcelout', params).then((res) => {
      utils.downloadFile(res);
    });
  };
  useEffect(() => {
    search();
  }, []);
  return (
    <div className={`${styles.pagePaymentEffect} page-Padding`}>
      {/* <div style={{display:"flex",marginBottom:"15px"}}>
        <div style={{width:3,height:14,backgroundColor:"#3399FF",marginRight:"8px"}}></div>
        <div style={{fontSize:"14px",lineHeight:"1"}}>效果汇总</div>
      </div> */}
      <div style={{ display: 'flex', marginBottom: '24px' }}>
        <div style={{ flex: '1' }}>
          <Radio.Group
            shape="button"
            dataSource={tabList}
            value={initTab}
            onChange={chooseTab}
            className="radioGroupStyleReSet"
          />

        </div>
        <div style={{ flex: '1' }}>
          <DatePicker.RangePicker
            popupAlign="tr tr"
            hasClear={false}
            value={[formSelect.startTime, formSelect.endTime]}
            onChange={selectTime}
            style={{ width: 380, marginTop: '2px', marginLeft: '10px' }}
            followTrigger
          />

        </div>

        <div>
          <Button
            type="primary"
            className={`${styles.mr10} ${styles.w88}`}
            onClick={() => search()}
            style={{ margin: '2px 0 0 10px' }}
          >查询
          </Button>

          <Button
            type="normal"
            className={`${styles.w88}`}
            onClick={resetFilter}
            style={{ margin: '2px 10px 0 10px' }}
          >重置
          </Button>

          <Button
            type="primary"
            className={styles.w88}
            onClick={downLoad}
            style={{ marginTop: '2px' }}
          >导出
          </Button>
        </div>
      </div>

      <div attr-intro="效果汇总" className={styles.effectDataShow}>

        <ParagraphTitle title="效果汇总" />

        <div className={styles.effectBox}>
          <div attr-intro="催付订单数" className={`${styles.innnerBox} ${styles.img1}`}>
            <Tooltip
              id="aria-tooltip"
              align="t"
              trigger={<div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '16px',
                  color: '#ffffff',
                  cursor: 'pointer',
                }}
                className={'iconfont icon-icon4-33'}
              />}
            >
              统计首次催付和二次催付的订单总量
            </Tooltip>
            <div className={styles.titleSize}>催付订单数</div>
            <div className={styles.numSize}>{utils.numFormat(dataEffect.promptOrderNum) || 0}</div>
          </div>
          <div attr-intro="挽回订单数" className={`${styles.innnerBox} ${styles.img2}`}>
            <Tooltip
              id="aria-tooltip"
              align="t"
              trigger={<div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '16px',
                  color: '#ffffff',
                  cursor: 'pointer',
                }}
                className={'iconfont icon-icon4-33'}
              />}
            >
              催付后付尾款的订单数
            </Tooltip>
            <div className={styles.titleSize}>挽回订单数</div>
            <div className={styles.numSize}>{utils.numFormat(dataEffect.returnOrderNum) || 0}</div>
          </div>
          <div attr-intro="挽回总金额" className={`${styles.innnerBox} ${styles.img3}`}>
            <Tooltip
              id="aria-tooltip"
              align="t"
              trigger={<div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '16px',
                  color: '#ffffff',
                  cursor: 'pointer',
                }}
                className={'iconfont icon-icon4-33'}
              />}
            >
              催付后付尾款的订单金额
            </Tooltip>
            <div className={styles.titleSize}>挽回总金额</div>
            <div className={styles.numSize}>{utils.numFormat(dataEffect.returnPayAmount) || 0}</div>
          </div>
          <div attr-intro="催付成功率" className={`${styles.innnerBox} ${styles.img4}`}>
            <Tooltip
              id="aria-tooltip"
              align="t"
              trigger={<div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '16px',
                  color: '#ffffff',
                  cursor: 'pointer',
                }}
                className={'iconfont icon-icon4-33'}
              />}
            >
              催付成功数/催付总数
            </Tooltip>
            <div className={styles.titleSize}>催付成功率</div>
            <div className={styles.numSize}>{dataEffect.successRate || 0}%</div>
          </div>
          <div attr-intro="ROI" className={`${styles.innnerBox} ${styles.img5}`}>
            <Tooltip
              id="aria-tooltip"
              align="tl"
              trigger={<div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '16px',
                  color: '#ffffff',
                  cursor: 'pointer',
                }}
                className={'iconfont icon-icon4-33'}
              />}
            >
              <div style={{ whiteSpace: 'nowrap' }}>挽回总金额/催付短信总成本</div>
            </Tooltip>
            <div className={styles.titleSize}>ROI</div>
            <div className={styles.numSize}>{dataEffect.roi || 0}</div>
          </div>
        </div>
      </div>

      <div attr-intro="每日效果分析" className={styles.childBox}>
        <ParagraphTitle title="每日效果分析" />
        {/* <div style={{ margin: "30px 0 15px", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          <div>每日效果分析</div>
          <Button type="secondary" className={styles.w88} onClick={downLoad}>导出</Button>
        </div> */}
        <div style={{ padding: '40px' }}>

          <Table dataSource={dataList} loading={isLoading} className={styles.customTable}>
            <Table.Column
              title={'日期'}
              align="left"
              cell={(value, index, item) => (
                <div>{moment(item.summaryTime).format('YYYY-MM-DD')}</div>
              )}
            />
            <Table.Column
              title="催款总金额（元）"
              align="left"
              cell={(value, index, item) => (
                <div>{(+item.promptPayAmount / 100).toFixed(2)}</div>
              )}
            />
            <Table.Column
              title="挽回总金额（元）"
              align="left"
              cell={(value, index, item) => (
                <div>{(+item.returnPayAmount / 100).toFixed(2)}</div>
              )}
            />
            <Table.Column
              title="挽回金额比例"
              align="left"
              cell={(value, index, item) => (
                <div>{item.returnPayAmountRate}%</div>
              )}
            />
            <Table.Column title="催付订单数" align="left" dataIndex="promptOrderNum" />
            <Table.Column
              title="挽回订单数"
              align="left"
              cell={(value, index, item) => (
                <div>{item.returnOrderNum}</div>
              )}
            />
            <Table.Column
              title="催付成功率"
              align="left"
              cell={(value, index, item) => (
                <div>{item.successRate}%</div>
              )}
            />
            <Table.Column
              title={<div>
                <span>ROI</span>
                <Tooltip
                  align="t"
                  trigger={<span
                    style={{ fontSize: '14px', marginLeft: '4px', cursor: 'pointer' }}
                    className={'iconfont icon-icon4-33'}
                  />}
                >
                  挽回总金额/催付短信总成本
                </Tooltip>
                     </div>}
              align="left"
              dataIndex="roi"
            />
          </Table>
          <LzPagination pageInfo={pageInfo} onChange={handleTaskPageSizeChange} />

        </div>
      </div>
    </div>
  );
};

export default PaymentEffect;
